import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.css';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from './design/ThemeProvider';

const container = document.getElementById('root');
if (container) {
	const root = ReactDOM.createRoot(container);
	root.render(
		<Provider store={store}>
			<React.StrictMode>
				{/* Themes the whole app: writes data-ds-* onto #root, which is
				    where the design tokens are declared. Default is Saga Gold
				    (locked while FEATURE_FLAGS.displaySettings is off). */}
				<ThemeProvider applyToRoot>
					<HashRouter>
						<App />
					</HashRouter>
				</ThemeProvider>
			</React.StrictMode>
		</Provider>
	);
}
